module.exports = __webpack_public_path__ + "media/img/pages/companies/solvias-0334059c2ad5e4ee1804fe8d8b92d6f8.png";